import { CollisionBox } from "../../../models/Model";
import { Vec3, Vec4, Vec2 } from "../../../models/SyntheticMap";
import { copyVec3, copyVec4 } from "../../../visuals/visual-utils";
import * as THREE from "three";
import { PhysXActor } from "./PhysXActor";
import { RobotPhysXActor } from "../robot/RobotPhysXActor";
import { PhysXScene } from "./PhysXScene";

export interface PhysXObject {
  _id: string;
  id: string;
  type: string;
  position: Vec3;
  rotation: Vec3;
  parentId?: string;
  boxes: CollisionBox[];
  props: any;
  obj?: THREE.Object3D;
  actor?: PhysXActor;
  screenPos?: Vec2; // Whether this object is in the camera plane
  maxLabelDistance?: number; // Whether this object needs a label
}

export function buildPhysXObject(object: PhysXObject, scene: PhysXScene, objects:Map<string, PhysXObject>): THREE.Group {
  const obj = new THREE.Group();
  obj.name = object._id;
  copyVec3(object.position, obj.position);
  copyVec3(object.rotation, obj.rotation);
  obj.userData.physXObject = object;
  object.boxes.forEach((box, index) => {
    const boxGeometry = new THREE.BoxGeometry(box.size.x, box.size.y, box.size.z);
    const boxMaterial = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
    const boxMesh = new THREE.Mesh(boxGeometry, boxMaterial);
    boxMesh.name = `${object._id}_box_${index}`;
    copyVec3(box.position, boxMesh.position);
    copyVec3(box.rotation, boxMesh.rotation);
    obj.add(boxMesh);
  });
  if (object.parentId) {
    const parentObject = objects.get(object.parentId);
    if (parentObject) {
      parentObject.obj!.add(obj);
    } else {
      console.warn(`Parent object with ID ${object.parentId} not found for object ${object._id}`);
    }
  } else {
    scene.scene.add(obj);
  }
  object.obj = obj;
  object.actor = new PhysXActor(object, scene);
  if (object.type === 'QuadrupedVisual') {
    object.actor = new RobotPhysXActor(object, scene);
  }
  return obj;
}